export function formatIdentifier(identifier: string) {
	const newIdentifier = identifier?.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
	return newIdentifier;
}

export function identifierReplaceAll(identifier: string) {
	return identifier.replaceAll(".", "").replaceAll("-", "").replaceAll("_", "");
}
